import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import cn from 'classnames'
import Loader from '../common/Loader'
import {showModal, CONFIRM, TEMP_QUESTION_MODAL, INFO} from '../../modules/modals'
import {tempQuestionsSortedSelector, tempCursorSelector, setTempCursor, removeTemp, currentTempPreviewItemSelector, checkAndUploadTemp, tempLoadStateSelector, saveTemp} from '../../modules/questions'
import minusButtonIcon from '../../_static/images/minusButton.svg'
import minusButtonActiveIcon from '../../_static/images/minusButtonActive.svg'
import trashIconActive from '../../_static/images/garbageIcon-white.svg'
import trashIcon from '../../_static/images/garbageIcon-gray.svg'
import {QBM_NAV_TEMP} from '../../modules/app'


class Temp extends Component {
    render() {
        const {openItemId, onClick} = this.props
        const isOpen = openItemId === QBM_NAV_TEMP
        const {formatMessage} = this.context
        return (
            <div className="qbm-accordion-component">
                <div className="qbm-accordion-title"  onClick={onClick}><div><span>{formatMessage("mnuBlueSharedQuestions")} </span><span id={"tempTicker"}>{
                    typeof window.tempState !== 'undefined' ?
                        `(${window.tempState})` :
                        ''
                }</span></div>
                    <div className={cn({"qbm-accordion-arrow":1, open : isOpen})}></div>
                </div>
                <div className={cn({"qbm-accordion-body":1, open : isOpen})}>
                    {
                        this.getBody()
                    }
                </div>
            </div>
        )
    }

    componentDidMount() {
        const {checkAndUploadTemp} = this.props
        checkAndUploadTemp()
        setInterval(function(){
            checkAndUploadTemp()
        }, 60000);
    }

    getBody = () => {
        const {temp, tempCursor, loading} = this.props
        const {Item} = this
        Item.displayName = "Item"
        if (loading) return <Loader className="accordion-sidebar-preloader" />

        return (
            <React.Fragment>
                <div className="qbm-accordion-content">
                    {
                        !temp.length &&
                        <span className="qbm-accordion-content__item-text qbm-accordion-content__item-text--no-x-borders">{this.context.formatMessage("mnuBlueSharedQuestMessage")}</span>
                    }
                    {
                        temp.map(({id, body : text}) => (
                            <Item
                                key = {id}
                                handleClick = {this.handleItemClick(id)}
                                text = {text}
                                isSelected = {tempCursor === id}
                                handleDoubleClick = {this.handleDoubleClick(id)}
                            />
                        ))
                    }
                </div>
                <div className="qbm-accordion-action-panel">
                    <div
                        onClick = {this.handleActionButtonClick('zoom')}
                        className="qbm-accordion-action-panel__action-button"
                    >
                        <span
                            className={cn("qbm-accordion-action-icon pointer", {"qbm-accordion-action-icon--active": !!tempCursor})}
                            title = {this.context.formatMessage("Details")}
                        >
                            <span className="glyphicon glyphicon-search"></span>
                        </span>
                    </div>
                    {/*<div
                        onClick = {this.handleActionButtonClick('recover')}
                        className="qbm-accordion-action-panel__action-button"
                    >
                        <span
                            className = {cn("qbm-accordion-action-icon pointer", {"qbm-accordion-action-icon--active": !!tempCursor})}
                            title = {this.context.formatMessage("Save")}
                        >
                            <span className="glyphicon glyphicon-repeat"></span>
                        </span>
                    </div>*/}
                    <div
                        onClick = {this.handleActionButtonClick('delete')}
                        className="qbm-accordion-action-panel__action-button"
                    >
                        <img
                            src={!!tempCursor ? minusButtonActiveIcon : minusButtonIcon}
                            alt = {this.context.formatMessage("Remove")}
                            title = {this.context.formatMessage("Remove")}
                        />
                    </div>

                    {/*<div
                        onClick = {this.handleActionButtonClick('delete-all')}
                        className="qbm-accordion-action-panel__action-button"
                    >
                        <img
                            src={temp.length ? trashIconActive : trashIcon}
                            alt = {this.context.formatMessage("Empty Trash")}
                            title = {this.context.formatMessage("Empty Trash")}
                        />
                    </div>*/}
                </div>
            </React.Fragment>
        )
    }

    Item = ({text, isSelected, handleClick, handleDoubleClick}) => (
        <div
            onClick = {handleClick}
            className = {cn("qbm-accordion-html-item pointer", {"qbm-accordion-html-item--active" : isSelected})}
            onDoubleClick = {handleDoubleClick}
            dangerouslySetInnerHTML = {{
                __html : text,
            }}
        />
    )

    handleItemClick = id => (event) => {
        event.preventDefault() // if there is a anchor in trashed question body (html)
        const {setTempCursor} = this.props
        setTempCursor({tempQuestionId : id})
    }

    handleDoubleClick = id => () => {
        const {setTempCursor} = this.props
        setTempCursor({tempQuestionId : id})
        this.handleZoom()
    }

    handleActionButtonClick = (action) => () => {
        const {tempCursor} = this.props

        if (action !== "delete-all" && !tempCursor && ["zoom", "recover", "delete"].includes(action)) return

        if (action === 'zoom') {
            this.handleZoom()
        } else if (action === 'recover') {
            this.handleRecover()
        } else if (action === 'delete') {
            this.handleRemove()
        } else if (action === "delete-all") {
            this.handleRemoveAll()
        }
    }

    handleRemoveAll = () => {
        const {temp, showModal, removeAllTrash, currentTemp : {form : {errors : {removeErr : errors = []} = {}} = {}} = {}} = this.props
        if (!temp.length) return
        const {formatMessage} = this.context
        showModal({
            modalType : CONFIRM,
            modalProps : {
                title : formatMessage("Empty Temp"),
                confirmText : formatMessage(`Are you sure you want permanently erase the items in the temp? You can’t undo this action.`),
                okButtonTxt : formatMessage("Yes"),
                cancelButtonTxt : formatMessage("Cancel"),
                okCb : () => removeAllTrash(),
                errors,
            }
        })
    }

    handleRemove = () => {
        const {showModal, tempCursor, removeTemp, currentTemp : {form : {errors : {removeErr : errors = []} = {}} = {}} = {}} = this.props
        const {formatMessage} = this.context
        showModal({
            modalType : CONFIRM,
            modalProps : {
                title : formatMessage("Deleting temp question"),
                confirmText : formatMessage(`Do you really want completely delete the question with id`) + `: ${tempCursor}?`,
                okButtonTxt : formatMessage("Yes"),
                cancelButtonTxt : formatMessage("No"),
                okCb : () => removeTemp({tempQuestionId : tempCursor}),
                errors,
            }
        })
    }

    handleZoom = () => {
        const {showModal} = this.props
        showModal({
            modalType : TEMP_QUESTION_MODAL,
            modalProps : {
                saveCB : () => {
                    this.handleSave()
                },
                removeCB : () => {
                    this.handleRemove()
                },
            }
        })
    }

    handleSave = () => {
        const {tempCursor, saveTemp} = this.props
        saveTemp({tempQuestionId : tempCursor})
    }

    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => {
        const {loading} = tempLoadStateSelector(state)
        const temp = tempQuestionsSortedSelector(state)
        const tempCursor = tempCursorSelector(state)
        const currentTemp = currentTempPreviewItemSelector(state)
        return {
            temp,
            tempCursor,
            currentTemp,
            loading,
        }
    },
    {showModal, setTempCursor, removeTemp, checkAndUploadTemp, saveTemp}
)(Temp)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/Temp.js